import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/coreFields';
import { descriptionField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { currencyField } from './common/expenditureFields';
import { msg } from '@lingui/core/macro';
import { foodFields } from './common/foodFields';

const foodSpendCurrencyQuantity: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Food spend',
    context: 'Expenditure on the food item.',
  }),
  externalDescription: msg({
    message: 'Expenditure on the food item.',
    context: 'Food spend',
  }),
};

export const foodSpendMetadata = {
  displayName: msg({
    message: 'Food expenses',
    context: 'Activity data schema name for food expenses',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...foodFields,
    currency: currencyField,
    currency_quantity: foodSpendCurrencyQuantity,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: foodSpendCurrencyQuantity,
    description: descriptionField,
  },
} as const satisfies BatMetadataConfigEntry;
